import { QuantitySelectSharedProps } from "./QuantitySelect.props";
import QuantitySelectButton from "./QuantitySelectButton/QuantitySelectButton.web";
import QuantitySelectIncrementor from "./QuantitySelectIncrementor/QuantitySelectIncrementor.web";

export type QuantitySelectProps = QuantitySelectSharedProps & {
  // add web-specific props
};

// Displays a button with "Select" text (selects an item with a quantity of 1)
// OR displays a form incrementor component with +/- buttons for selecting other quantities of an item
export default function QuantitySelect(props: QuantitySelectProps) {
  const {
    dataTestId = "quantity-select",
    isDisabled,
    incrementorProps,
    buttonProps,
  } = props;

  if (buttonProps && buttonProps.showButton) {
    return (
      <QuantitySelectButton
        dataTestId={`${dataTestId}-button`}
        isDisabled={isDisabled}
        {...buttonProps}
      />
    );
  }

  if (incrementorProps && incrementorProps.showIncrementor) {
    return (
      <QuantitySelectIncrementor
        dataTestId={`${dataTestId}-incrementor`}
        isDisabled={isDisabled}
        {...incrementorProps}
      />
    );
  }

  return <></>;
}
